export const standardOutlinedStackProps = {
    direction: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    height: '130%',
    gap: 1,
    width: undefined,
    boxSizing: 'border-box',
    paddingInline: 2,
    borderRadius: 1,
    paddingBlock: 0.5,
    border: (t) => `1px solid ${t.palette.action.disabled}`,
    sx: {
        [`&:hover`]: {
            border: (t) => `1px solid ${t.palette.action.active}`,
        },
    },
};
export const standardStackLabelProps = {
    sx: {
        position: 'absolute',
        top: -10,
        left: 8,
        px: 0.5,
        background: 'white', // or your container bg
        fontSize: '0.75rem',
        color: 'text.secondary',
        fontFamily: 'inherit',
        fontWeight: 200,
    },
};
